import { ActionReducerMapBuilder, Draft, PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NoInfer } from '@reduxjs/toolkit/src/tsHelpers';

import { GeoReferensState, Lan, LanKommun, ModelError } from 'models';

import { errorOr } from './storeHelpers';

import BebyggelseApi from 'api/bebyggelseApi';

const initialState: GeoReferensState = {
  requestStatus: 'idle',
  data: {
    kommun: [],
    lan: []
  }
};

export const getKommun = createAsyncThunk<LanKommun[], undefined, { rejectValue: ModelError }>(
  'kommun/fetch',
  async (_value: undefined, { rejectWithValue }) => {
    const result = await BebyggelseApi.fetchKommuner();
    return errorOr(result, rejectWithValue);
  }
);

export const getLan = createAsyncThunk<Lan[], undefined, { rejectValue: ModelError }>(
  'lan/fetch',
  async (_value: undefined, { rejectWithValue }) => {
    const result = await BebyggelseApi.fetchLan();
    return errorOr(result, rejectWithValue);
  }
);

const geoReferensdataSlice = createSlice({
  name: 'geoReferens',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<GeoReferensState>>) => {
    builder.addCase(getKommun.pending, (state: Draft<GeoReferensState>) => {
      state.requestStatus = 'pending';
    });
    builder.addCase(getKommun.fulfilled, (state: Draft<GeoReferensState>, action: PayloadAction<LanKommun[]>) => {
      state.data.kommun = action.payload;
      state.requestStatus = 'idle';
    });
    builder.addCase(getKommun.rejected, (state: Draft<GeoReferensState>) => {
      state.requestStatus = 'rejected';
    });
    builder.addCase(getLan.pending, (state: Draft<GeoReferensState>) => {
      state.requestStatus = 'pending';
    });
    builder.addCase(getLan.fulfilled, (state: Draft<GeoReferensState>, action: PayloadAction<Lan[]>) => {
      state.data.lan = action.payload;
      state.requestStatus = 'idle';
    });
    builder.addCase(getLan.rejected, (state: Draft<GeoReferensState>) => {
      state.requestStatus = 'rejected';
    });
  }
});

export default geoReferensdataSlice.reducer;
